import './ServiceList.less';

import React from 'react';
import MaybeWrap from '@plone/volto/components/manage/MaybeWrap/MaybeWrap';
import cx from 'classnames';
import AnimateHeight from 'react-animate-height';

import { EmptyMessage } from '../EmptyMessage';
import { ErrorMessage } from '../ErrorMessage';

const ServiceList = ({
  title,
  listName,
  icon,
  iconColor,
  showRanking,
  showCategory,
  showIcon,
  items,
  emptyTitle,
  emptyMessage,
  errorTitle,
  errorMessage,
  open,
  loading,
  setOpen,
  error,
  // Acessibilidade / carrossel
  isActive = true,
  tabIndexOverride,
}) => {
  const effectiveOpen = open && !loading;

  const rootClasses = cx('service-list', 'shadow-sm', {
    'is-open': effectiveOpen,
    'is-loading': loading,
    'is-inactive': !isActive,
  });

  const itemList = error ? (
    <ErrorMessage title={errorTitle} message={errorMessage} />
  ) : (items || []).length === 0 ? (
    <EmptyMessage title={emptyTitle} message={emptyMessage} />
  ) : (
    <div
      className={cx('service-list__items', 'recom-list', listName)}
      data-recom-type={listName}
    >
      {items.map((item, position) => {
        const tabIndex =
          typeof tabIndexOverride === 'number'
            ? tabIndexOverride
            : isActive
              ? 0
              : -1;

        return (
          <a
            key={`${item.id}-${position}`}
            href={item.path}
            target="_blank"
            rel="noopener noreferrer"
            className={cx('service-list__item', 'servico')}
            tabIndex={tabIndex}
            aria-hidden={!isActive}
          >
            {showRanking && (
              <span className="service-list__rank">{position + 1}</span>
            )}

            {showIcon && item['category-icon'] && (
              <span
                className={cx(
                  'service-list__category-icon',
                  item['category-icon'],
                )}
                aria-hidden="true"
              />
            )}

            <MaybeWrap condition={showCategory}>
              {showCategory && item.category && (
                <div className="service-list__category">{item.category}</div>
              )}
              <span className="service-list__name">{item.title}</span>
            </MaybeWrap>
          </a>
        );
      })}
    </div>
  );

  return (
    <div className={rootClasses} aria-hidden={!isActive}>
      <button
        type="button"
        className={cx('service-list__toggle', {
          'is-loading': loading,
        })}
        onClick={(e) => {
          if (loading) {
            e.preventDefault();
            e.stopPropagation();
            return;
          }
          setOpen(!open);
        }}
        aria-expanded={effectiveOpen}
        aria-busy={loading}
        aria-disabled={loading}
        disabled={loading}
        tabIndex={isActive ? 0 : -1}
        style={loading ? { pointerEvents: 'none' } : undefined}
      >
        <span
          className={cx('service-list__icon', icon)}
          style={{ color: iconColor }}
          aria-hidden="true"
        />

        <span className="service-list__label">{title}</span>

        {loading ? (
          <span
            className={cx(
              'service-list__icon',
              'service-list__icon--spinner',
              'fa-solid',
              'fa-spinner',
              'fa-spin',
            )}
            aria-hidden="true"
          />
        ) : (
          <span
            className={cx(
              'service-list__icon',
              'service-list__icon--chevron',
              'fa-solid',
              `fa-angle-${effectiveOpen ? 'up' : 'down'}`,
            )}
            aria-hidden="true"
          />
        )}
      </button>

      <AnimateHeight
        id="services-animate-height"
        height={effectiveOpen ? 'auto' : 0}
        duration={300}
        easing="ease"
        animateOpacity
        className="service-list__dropdown"
      >
        {itemList}
      </AnimateHeight>
    </div>
  );
};

export default ServiceList;
